var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3763 13C1.88053 13 0.667969 11.7874 0.667969 10.2917V3.20833C0.667969 1.71256 1.88053 0.5 3.3763 0.5H14.6263C16.1221 0.5 17.3346 1.71256 17.3346 3.20833V10.2917C17.3346 11.7874 16.1221 13 14.6263 13H9.80531L5.31642 16.1811C4.9409 16.4472 4.42077 16.3584 4.15469 15.9829C4.0549 15.8421 4.0013 15.6737 4.0013 15.5013L4.00064 13H3.3763Z",
    fill: "#1D72E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFilled);
export default __webpack_public_path__ + "static/media/comment_filled.46d7f51dc7805a2676f0aad582ae1384.svg";
export { ForwardRef as ReactComponent };